import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {ErrorHandler, NgModule} from '@angular/core';
import {AngularFireModule, FIREBASE_OPTIONS} from '@angular/fire/compat';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {getDatabase, provideDatabase} from '@angular/fire/database';
import {AngularFireAuth, AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireDatabase, AngularFireDatabaseModule} from '@angular/fire/compat/database';
import {AngularFirePerformanceModule} from '@angular/fire/compat/performance';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {IntercomModule} from 'ng-intercom';
import {CookieService} from 'ngx-cookie-service';
import {
  CoreModule as Q9CoreModule,
  ConfigService,
  FirebaseConfig,
  FirebaseModule,
  CachedHttpTranslationLoader,
  provideMaterialSettings
} from '@q9elements/ui-kit/common';
import {LoadingPlaceholderModule} from '@q9elements/ui-kit/components';
import {environment} from '../environments/environment';
import {AppComponent} from './app.component';
import {authInterceptor} from './app.interceptors';
import {appRoutes} from './app.routes';
import {CommandsModule} from './commands/commands.module';
import {CoreModule} from './core/core.module';
import {GlobalErrorHandler} from './core/helpers/global-error-handler';
import {DiagramDataModule} from './diagram-data/diagram-data.module';
import {DiagramInteractionModule} from './diagram-interaction/diagram-interaction.module';
import {EditorInterfaceModule} from './editor-interface/editor-interface.module';
import {EncodeHtmlPipe} from './editor-interface/shared/pipes/encode-html.pipe';
import {EditorStateModule} from './editor-state/editor-state.module';
import {InitGuard} from './resolves/init.guard';
import {NoUiResolve} from './resolves/noui.resolve';
import {QueryParamGuard} from './resolves/query-param.guard';
import {ViewResolve} from './resolves/view-resolve.resolver';

ConfigService.setConfig({environment, appName: 'DiagramEditor'});

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    DiagramDataModule,
    DiagramInteractionModule,
    EditorInterfaceModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.fbConfig as Partial<FirebaseConfig>),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    FirebaseModule,
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    EditorStateModule,
    CommandsModule,
    RouterModule.forRoot(appRoutes, {onSameUrlNavigation: 'reload'}),
    TranslateModule.forRoot({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useClass: CachedHttpTranslationLoader
      }
    }),
    IntercomModule.forRoot({appId: environment.INTERCOM_APP_ID, updateOnRouterChange: true}),
    AngularFirePerformanceModule,
    Q9CoreModule,
    MatSnackBarModule,
    LoadingPlaceholderModule
  ],
  providers: [
    {
      provide: FIREBASE_OPTIONS,
      useValue: environment.fbConfig
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    provideMaterialSettings(),
    provideHttpClient(withInterceptors([authInterceptor])),
    CookieService,
    InitGuard,
    AngularFireAuth,
    AngularFireDatabase,
    ViewResolve,
    QueryParamGuard,
    NoUiResolve,
    EncodeHtmlPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
